"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionsStrForComaring = exports.initFilterSelectorContainerState = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
var react_1 = __importStar(require("react"));
var useFnsByKeyCode_1 = require("../../../lib/customHooks/useFnsByKeyCode");
var actions_1 = require("./actions");
var reducers_1 = __importDefault(require("./reducers"));
var initDefaultSelectedText = '--請選擇路線';
exports.initFilterSelectorContainerState = ({
    selectedIndex: 0,
    selectedText: initDefaultSelectedText,
    isDisplaySelects: false,
    filterInput: '',
    filteredOptions: [],
});
exports.getOptionsStrForComaring = function (options) {
    return options.map(function (o) { return o.value; }).join(',');
};
var useFilterSelector = function (props) {
    var matchCase = props.matchCase, _a = props.defaultSelectedText, defaultSelectedText = _a === void 0 ? initDefaultSelectedText : _a, defaultSelectedSingleSelectorOption = props.defaultSelectedSingleSelectorOption, options = props.options, getSelectedOptionFn = props.getSelectedOptionFn;
    var optionsStrForComaring = exports.getOptionsStrForComaring(options);
    var _b = react_1.default.useReducer(reducers_1.default, (__assign(__assign({}, exports.initFilterSelectorContainerState), { selectedText: defaultSelectedText }))), state = _b[0], dispatch = _b[1];
    var handleSelect = react_1.useCallback(function (selectedIndex) {
        var payload = {
            selectedIndex: selectedIndex,
            options: state.filteredOptions,
            getSelectedOptionFn: getSelectedOptionFn
        };
        dispatch(actions_1.select(payload));
    }, [state.filteredOptions, getSelectedOptionFn]);
    var handleSelectByEnter = react_1.useCallback(function () {
        if (typeof state.selectedIndex === 'number' && state.isDisplaySelects) {
            handleSelect(state.selectedIndex);
        }
    }, [state.selectedIndex, state.isDisplaySelects, handleSelect]);
    var handleResetSelect = react_1.useCallback(function () {
        dispatch(actions_1.resetSelect({
            options: options,
            defaultSelectedText: defaultSelectedText,
        }));
    }, [defaultSelectedText, optionsStrForComaring]);
    var handleToggleDisplaySelects = react_1.useCallback(function () {
        dispatch(actions_1.toggleDisplaySelects());
    }, []);
    var handleCloseDisplaySelects = react_1.useCallback(function () {
        if (state.isDisplaySelects) {
            dispatch(actions_1.toggleDisplaySelects());
        }
        ;
    }, [state.isDisplaySelects]);
    var handleFilter = react_1.useCallback(function (e) {
        var filterInput = e.target.value;
        var payload = {
            matchCase: matchCase,
            filterInput: filterInput,
            options: options,
        };
        dispatch(actions_1.filter(payload));
    }, [optionsStrForComaring]);
    var handleSetDefaultSelectedOption = react_1.useCallback(function () {
        if (defaultSelectedSingleSelectorOption) {
            var selectedIndex = options.findIndex(function (o) {
                return o.value === defaultSelectedSingleSelectorOption.value;
            });
            if (selectedIndex !== -1) {
                var selectedText = options[selectedIndex].text;
                var action = actions_1.setState({
                    selectedIndex: selectedIndex,
                    selectedText: selectedText,
                });
                dispatch(action);
            }
        }
    }, [defaultSelectedSingleSelectorOption, optionsStrForComaring]);
    var _c = useFnsByKeyCode_1.useFnsByKeyCode({
        lastIndex: state.filteredOptions.length - 1,
        confirmFn: handleSelectByEnter,
        escapeFn: handleCloseDisplaySelects,
    }), index = _c.index, setIndex = _c.setIndex;
    react_1.default.useEffect(function () {
        handleResetSelect();
    }, [handleResetSelect]);
    react_1.default.useEffect(function () {
        var defaultIndex = 0;
        setIndex(defaultIndex);
        dispatch(actions_1.setState({
            selectedIndex: defaultIndex,
        }));
    }, [state.filteredOptions.length]);
    react_1.default.useEffect(function () {
        dispatch(actions_1.setState({
            selectedIndex: index,
        }));
    }, [index]);
    react_1.default.useEffect(function () {
        handleSetDefaultSelectedOption();
    }, [handleSetDefaultSelectedOption]);
    return ({
        index: index,
        setIndex: setIndex,
        state: state,
        handleFilter: handleFilter,
        handleSelect: handleSelect,
        handleSelectByEnter: handleSelectByEnter,
        handleResetSelect: handleResetSelect,
        handleCloseDisplaySelects: handleCloseDisplaySelects,
        handleToggleDisplaySelects: handleToggleDisplaySelects,
        handleSetDefaultSelectedOption: handleSetDefaultSelectedOption,
    });
};
exports.default = useFilterSelector;
